/**
 * @Author: zyl
 * @Date: 2024-01-22 09:47:16
 * @LastEditors: Ygm
 * @LastEditTime: 2026-05-19 17:41:44
 * @Description: 接口请求服务
 */

const isDev = process.env.NODE_ENV === 'development'
const baseConfig = {
  // sKey: sKey,
}

/**
 * @param {Boolean} isDev
 * @description
 */
function createGlobalConfig(isDev) {
  let obj = {
    ...baseConfig
  }
  if (isDev) {
    obj.dataService = '/gateway_api'
    // obj.dataService = '/dev_api'
  } else {
    obj.dataService = window.location.origin
  }
  return obj
}

let G = createGlobalConfig(isDev)
if (sessionStorage && Object.keys(sessionStorage).length) {
  Object.keys(sessionStorage).forEach((item, index) => {
    try {
      G[item] = JSON.parse(sessionStorage[item])
    } catch (e) {
      G[item] = sessionStorage[item]
    }
  })
}

if (window) {
  window.G = G
}

export default G



// WEBPACK FOOTER //
// ./src/config/g.js